import useTranslator from "../../hooks/useTranslator";
import { useLocation, useNavigate } from "react-router-dom";
import { getGuarantorStatus, haveValue, toast } from "../../helper/common";
import DeleteConfiration from "./DeleteConfiration";
import { useContext, useState } from "react";
import ApplicationContext from "../../context/application/ApplicationContext";
import TenantContext from "../../context/tenant/TenantContext";
import AuthContext from "../../context/auth/AuthContext";
import { Checkbox, Icon } from "../design";
import {
  GuarantorCard,
  GuarantorMenu,
  GuarantorStatusBadge,
} from "./GuarantorCardParts";

const EarnerCard = ({
  handleUpdateSource,
  userData,
  type,
  setUpdateSourceObj,
  allowViewProfile = true,
  showReportIcons = true,
  guarantorView = false,
  user,
  onClose = () => {},
  isDropdown,
  setIsDropdown,
  isEnabled,
  toggleIncomeSource,
  showIncomeSourceSelector,
  llShowOnly,
  readOnly = false,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const location = useLocation();
  const [showDeleteConfirmationPrompt, setShowDeleteConfirmationPrompt] =
    useState(false);
  const { removeGuarantor } = useContext(TenantContext);
  const { reloadApplications } = useContext(ApplicationContext);
  const [deleteGuarantorLoading, setDeleteGuarantorLoading] = useState(false);
  const { loadUser } = useContext(AuthContext);

  const checkGuarantorProfile = (guarantor_id) => {
    const fullPath = location.pathname + location.search;
    navigate(
      `${fullPath}${
        haveValue(location.search) ? "&" : "?"
      }guarantor=${guarantor_id}`
    );
  };

  const handleChangeSource = () => {
    handleUpdateSource();
    setUpdateSourceObj({
      _id: userData?.all_sources?._id,
      all_sources: userData?.all_sources,
      current_selected: userData?.source,
      current_income_mode: userData?.source_mode,
      type,
    });
  };

  const deleteGuarantor = async (_id) => {
    try {
      setDeleteGuarantorLoading(true);
      await removeGuarantor(_id);
      loadUser("tenant");
      // they also left the applications where they were this tenant's guarantor
      reloadApplications?.().catch(() => {});
      setShowDeleteConfirmationPrompt(false);
    } catch (err) {
      toast.error(_t("failedToDeleteGuarantor"));
    } finally {
      setDeleteGuarantorLoading(false);
    }
  };

  const formatNetMonthlyIncome = (rawAmount) => {
    const numericAmount = Number(rawAmount);
    if (!Number.isFinite(numericAmount)) return "";
    const formattedAmount = new Intl.NumberFormat("es-ES").format(
      numericAmount
    );
    return `${formattedAmount} ${_t("euroPerMonthNet", "€/month net")}`;
  };

  const guarantorStatus = getGuarantorStatus("accepted", userData?.all_sources);
  const isCompleted = guarantorStatus?.status === "completed";
  const showStatus = allowViewProfile && showReportIcons;
  const showMenu =
    showStatus &&
    type === "guarantor" &&
    !readOnly &&
    (!llShowOnly || isCompleted);

  const menuItems = [];
  if (isCompleted) {
    menuItems.push({
      key: "view",
      label: _t("viewProfile"),
      icon: <Icon name="eye" />,
      onClick: () => {
        onClose();
        checkGuarantorProfile(userData?.all_sources?._id);
      },
    });
  }
  if (!llShowOnly) {
    menuItems.push({
      key: "delete",
      label: _t("delete"),
      icon: <Icon name="trash" />,
      danger: true,
      onClick: () => setShowDeleteConfirmationPrompt(true),
    });
  }

  const name = haveValue(userData?.all_sources?.name)
    ? userData?.all_sources?.name
    : type === "tenant" && haveValue(user)
      ? `${user?.fname ?? ""} ${user?.lname ?? ""}`.trim()
      : "";
  const relation = haveValue(userData?.gurantor_relation)
    ? _t(userData?.gurantor_relation)
    : type !== "guarantor"
      ? _t(type)
      : null;

  const card = (
    <>
      <GuarantorCard
        bare={showIncomeSourceSelector}
        name={name}
        relation={relation}
        email={userData?.all_sources?.user_email}
        amount={formatNetMonthlyIncome(
          llShowOnly ? userData?.amount : userData?.all_sources?.declaredIncome
        )}
        status={
          showStatus ? (
            <GuarantorStatusBadge statusData={guarantorStatus} />
          ) : null
        }
        menu={
          showMenu && menuItems.length > 0 ? (
            <GuarantorMenu
              label={_t("more", "More")}
              items={menuItems}
              open={isDropdown}
              onToggle={() => setIsDropdown(!isDropdown)}
            />
          ) : null
        }
      />
      <DeleteConfiration
        isOpen={showDeleteConfirmationPrompt}
        onClose={() => setShowDeleteConfirmationPrompt(false)}
        name={userData?.all_sources?.name ?? ""}
        relation={userData?.gurantor_relation ?? ""}
        heading={_t("deleteGuarantor")}
        description={_t("areYouSureDoYouWantToDeleteThisGuarantor")}
        btn1Text={_t("noGoBack")}
        btn2Text={_t("yesDelete")}
        btn1Functionality={() => setShowDeleteConfirmationPrompt(false)}
        btn2Functionality={() => deleteGuarantor(userData?.all_sources?._id)}
        submitLoading={deleteGuarantorLoading}
      />
    </>
  );

  if (!showIncomeSourceSelector) return card;

  return (
    <div
      className={`income-source-checkbox-card mb-3 income-source-card-wrapper ${
        isEnabled ? "income-source-card-wrapper-active" : ""
      }`}
    >
      <Checkbox
        onChange={() => toggleIncomeSource(userData?.all_sources?._id)}
        checked={isEnabled}
      />
      {card}
    </div>
  );
};

export default EarnerCard;
